module.exports = "/cyber/_next/static/images/gift-box-e335c0991b594513c9accb3f104098a6.png";